import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import App from "./App";

const container = document.getElementById("root");
const app = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Prerendered pages (see prerender.js) ship with markup in #root — hydrate those;
// fall back to a normal client render otherwise.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app, {
    onRecoverableError: () => {},
  });
} else {
  ReactDOM.createRoot(container).render(app);
}
